import { RegistrationFormContainer } from './registrationFormContainer';
import { RegistrationUserFormContainer } from './registrationUserFormContainer';

export { RegistrationUserFormContainer };

export default RegistrationFormContainer;